import { forwardRef } from "react";
import {
  TextArea as ReactAriaTextArea,
  TextField as ReactAriaTextField,
  type TextFieldProps as ReactAriaTextFieldProps,
} from "react-aria-components";
import { FieldError } from "react-hook-form";

import { cn } from "../utils";
import { NcFieldLayout, NcFieldLayoutProps } from "./nc-field-layout";
import { ncInputClasses } from "./nc-input";
import { NcLabel } from "./nc-label";

export interface NcTextAreaProps extends Omit<ReactAriaTextFieldProps, "type"> {
  label: string;
  hideLabel?: boolean;
  description?: string;
  variant?: NcFieldLayoutProps["variant"];
  error?: FieldError;
  autoComplete?: string;
  autoCapitalize?: string;
  maxLength?: number;
}

export const NcTextArea = forwardRef<HTMLTextAreaElement, NcTextAreaProps>(
  (
    {
      label,
      hideLabel,
      description,
      isRequired,
      variant,
      error,
      autoComplete = "off",
      autoCapitalize = "none",
      maxLength = 4000,
      ...props
    },
    ref
  ) => (
    <ReactAriaTextField {...props}>
      <NcFieldLayout variant={variant}>
        <NcLabel isRequired={isRequired} hideLabel={hideLabel}>
          {label}
        </NcLabel>
        <ReactAriaTextArea
          data-nc="NcTextArea"
          ref={ref}
          className={cn(ncInputClasses, "field-sizing-content min-h-32 w-full min-w-48")}
          autoComplete={autoComplete}
          autoCapitalize={autoCapitalize}
          maxLength={maxLength}
        />
        {description && <NcFieldLayout.Description>{description}</NcFieldLayout.Description>}
        <NcFieldLayout.ErrorMessage>{error?.message}</NcFieldLayout.ErrorMessage>
      </NcFieldLayout>
    </ReactAriaTextField>
  )
);
